import axios from "axios";

const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL
  // baseURL: "https://kas-api.swaasa.ai:8085/api",
  // baseURL: "https://kas-api.swaasa.ai:8086/api",
    //  baseURL: 'https://5c11-2406-b400-d4-4fac-11e2-5835-61cb-4f96.ngrok-free.app'

  // baseURL: "https://api.swaasa-app.swaasa.ai:8000/api",
  // baseURL: "https://2250-2406-b400-d4-2d99-6974-33c2-47c9-41af.ngrok-free.app/api"
});

export default instance;
